<div *ngIf="router.url.includes('Summer-play')" id="mobMap"></div>
<div *ngIf="router.url.includes('Field-meander')" id="mobMap1"></div>
<div *ngIf="router.url.includes('Field-bio')" id="mobMap2"></div>